import type * as React from 'react';
import { cn } from '@/shared/lib/cn';

type InputProps = Omit<React.ComponentProps<'input'>, 'size'> & {
  /** `compact` is the workspace density. */
  size?: 'default' | 'compact';
};

/** Shared classes for text-like controls: pale blue fill, white when `data-on="ground"`. */
export const controlSurface =
  'w-full min-w-0 rounded-sm border border-input bg-input-fill text-foreground transition-colors duration-150 ease-standard placeholder:text-muted-foreground data-[on=ground]:bg-card hover:border-ring/40 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive';

/** Text input. Put `data-on="ground"` on it when it sits directly on the page ground. */
function Input({ className, type, size = 'default', ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size}
      className={cn(
        controlSurface,
        'px-3 file:mr-3 file:h-full file:cursor-pointer file:border-0 file:bg-transparent file:font-bold file:text-accent-foreground',
        size === 'compact' ? 'h-8 text-sm' : 'h-10 text-base',
        className,
      )}
      {...props}
    />
  );
}

export { Input, type InputProps };
